import React, { useEffect, useRef } from 'react';
import { logEvent } from 'utils/analytics';
import EulerBeatsWrapper from 'utils/EulerBeatsWrapper';

interface VisualizationProps {
  seed: string;
  size?: string | number;
  isPrint?: boolean;
  onPlay? : (arg0: PlayState) => void;
}

export enum PlayState {
  start='start',
  stop="stop",
  end="end",
}

const Visualization = ({ seed, isPrint, size = 480, onPlay }: VisualizationProps) => {
  const playerEl = useRef(null);
  const elementId = `eulerbeats-${isPrint ? 'print' : 'original'}-${seed}`;
  const seedToRender = seed.startsWith('0x') ? seed : '0x' + seed

  useEffect(() => {
    const element = playerEl.current;

    element &&
      window.EulerBeatsGenesis.visual.render(element, seedToRender, size, (elementId: string, event: PlayState) => {
        if (onPlay) {
          onPlay(event);
        } else {
          const toggleElement = document.getElementById(`${elementId}-toggle`);
          if (toggleElement) {
            if (event === 'start') {
              toggleElement.classList.add('is-playing');
            } else if (event === 'stop') {
              toggleElement.classList.remove('is-playing');
            }
          }
        }
      });

    return () => {
      EulerBeatsWrapper.visual.stop();
    };
  }, [size, seedToRender, onPlay]);

  const handleClick = () => {
    logEvent('click_visualization', {
      event_category: 'EulerBeat Interaction',
      event_label: 'Click on visualization',
      name: elementId,
    });
  }

  return (
    <div
      id={elementId}
      ref={playerEl}
      onClick={handleClick}
    />
  );
};

export default Visualization;
